import { render, staticRenderFns } from "./dev_page.vue?vue&type=template&id=48916faa&"
import script from "./dev_page.vue?vue&type=script&lang=js&"
export * from "./dev_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports